import { Box } from "@mui/material";

import { useSideBar } from "./hooks/useSidebar";

const SideMenu = () => {
    const { menuContent } = useSideBar();
    
    return (
        <Box sx={{ 
            flexShrink: 0,
            height: "100%",
            display: "flex",
            flexDirection: "column"
        }}>
            {menuContent}
        </Box>
    )
}

export default SideMenu;